// extracted by mini-css-extract-plugin
export default {"container":"ControlPanel_container__0a+oe","controls":"ControlPanel_controls__cvw4f"};